// noinspection JSUnusedGlobalSymbols

/*
 * Copyright (c) 2022. American Express Company
 */

export enum JaegerEvent {
    DRAG_START = 'dragstart',
    DRAG_END = 'dragend',
    DRAG_MOVE = 'dragmove',
    MOUSE_DOWN = 'mousedown',
    MOUSE_ENTER = 'mouseenter',
    MOUSE_OVER = 'mouseover',
    MOUSE_LEAVE = 'mouseleave',
    CLICK = 'click',
    CONTEXT_MENU = 'contextmenu',
    TOUCH_START = 'touchstart',
    TOUCH_MOVE = 'touchmove',
    TOUCH_END = 'touchend',
    WHEEL = 'wheel'
}
